import styled from 'styled-components/macro'

export const Wrapper = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #7dd3fc 0%, #38bdf8 100%);
  padding: 80px 20px;
  display: flex;
  justify-content: center;
  align-items: flex-start;

  @media (max-width: 768px) {
    padding: 40px 16px;
  }
`

export const Article = styled.article`
  max-width: 1200px;
  width: 100%;
  background: white;
  border-radius: 24px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  overflow: hidden;
`

export const Header = styled.header`
  background: linear-gradient(135deg, #11b7f3 0%, #0891c7 100%);
  padding: 60px 40px;
  text-align: center;
  color: white;

  @media (max-width: 768px) {
    padding: 40px 24px;
  }

  .logo {
    width: 48px;
    height: 48px;
    margin-bottom: 24px;
    filter: brightness(0) invert(1);
  }

  h1 {
    font-size: 42px;
    font-weight: 700;
    margin: 0;
    line-height: 1.2;
    letter-spacing: -0.02em;

    @media (max-width: 768px) {
      font-size: 32px;
    }
  }

  .subtitle {
    font-size: 18px;
    opacity: 0.9;
    margin-top: 16px;
    font-weight: 400;

    @media (max-width: 768px) {
      font-size: 16px;
    }
  }

  .meta {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    margin-top: 24px;
    font-size: 14px;
    opacity: 0.85;

    .author {
      display: flex;
      align-items: center;
      gap: 8px;

      img {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        border: 2px solid rgba(255, 255, 255, 0.3);
      }
    }
  }
`

export const Content = styled.div`
  padding: 60px 60px 80px;
  font-size: 17px;
  line-height: 1.8;
  color: #333;

  @media (max-width: 768px) {
    padding: 40px 24px 60px;
    font-size: 16px;
  }

  p {
    margin: 0 0 24px 0;
    text-align: left;
  }

  h2 {
    font-size: 32px;
    font-weight: 700;
    color: #1a1a1a;
    margin: 48px 0 24px 0;
    line-height: 1.3;
    letter-spacing: -0.01em;

    @media (max-width: 768px) {
      font-size: 26px;
      margin: 40px 0 20px 0;
    }

    &:first-child {
      margin-top: 0;
    }
  }

  h3 {
    font-size: 24px;
    font-weight: 600;
    color: #2d3748;
    margin: 40px 0 20px 0;
    line-height: 1.4;

    @media (max-width: 768px) {
      font-size: 20px;
      margin: 32px 0 16px 0;
    }
  }

  h4 {
    font-size: 20px;
    font-weight: 600;
    color: #4a5568;
    margin: 32px 0 16px 0;
    line-height: 1.5;

    @media (max-width: 768px) {
      font-size: 18px;
    }
  }

  strong, b {
    font-weight: 600;
    color: #1a1a1a;
  }

  a {
    color: #11b7f3;
    text-decoration: none;
    font-weight: 500;
    border-bottom: 1px solid transparent;
    transition: all 0.2s ease;

    &:hover {
      color: #0891c7;
      border-bottom-color: #0891c7;
    }
  }

  ul {
    margin: 24px 0;
    padding-left: 24px;
    text-align: left;

    li {
      margin: 12px 0;
      line-height: 1.7;

      &::marker {
        color: #11b7f3;
      }
    }
  }

  .highlight {
    background: linear-gradient(135deg, #11b7f315 0%, #0891c715 100%);
    border-left: 4px solid #11b7f3;
    padding: 24px;
    margin: 32px 0;
    border-radius: 8px;
    font-size: 16px;
    line-height: 1.7;

    @media (max-width: 768px) {
      padding: 20px;
      margin: 24px 0;
    }
  }

  .info-box {
    background: #f7fafc;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 32px;
    margin: 32px 0;

    @media (max-width: 768px) {
      padding: 24px;
      margin: 24px 0;
    }
  }
`

export const Footer = styled.footer`
  background: #f7fafc;
  padding: 40px 60px;
  border-top: 1px solid #e2e8f0;
  text-align: center;

  @media (max-width: 768px) {
    padding: 32px 24px;
  }

  h3 {
    font-size: 20px;
    font-weight: 600;
    color: #2d3748;
    margin: 0 0 24px 0;
  }

  .company-info {
    font-size: 15px;
    line-height: 1.8;
    color: #4a5568;

    strong {
      color: #1a1a1a;
      display: block;
      margin-bottom: 8px;
    }

    a {
      color: #11b7f3;
      text-decoration: none;
      font-weight: 500;

      &:hover {
        color: #0891c7;
      }
    }
  }

  .links {
    margin-top: 32px;
    padding-top: 32px;
    border-top: 1px solid #e2e8f0;
    display: flex;
    justify-content: center;
    gap: 24px;
    flex-wrap: wrap;
    font-size: 14px;

    a {
      color: #11b7f3;
      text-decoration: none;
      font-weight: 500;

      &:hover {
        color: #0891c7;
      }
    }
  }
`
